import { StateType } from 'data/types'

const getState = (state: StateType) => state.payments.eligible

export const getEligibility = (state: StateType) => (currency: string) =>
  getState(state)[currency]?.data

export const isFetchingEligibility = (state: StateType) => (currency: string) => {
  const localState = getState(state)[currency]
  if (!localState) return false
  const { fetching } = localState
  if (fetching === undefined) return false
  return fetching
}

export const canBankTransfer = (state: StateType) => (currency: string) =>
  !!getEligibility(state)(currency)?.find((e) => e.type === 'BANK_TRANSFER')
